export default () => ({
  token: {
    jwt: null,
    validUntil: null,
  },
  roles: [],
  portals: [],
  currentPortal: null,
})
